import {useAppSelector} from "./redux";
import {selectCurrentUser} from "../features/users/model/selectors";

export const useIsAdmin = (): boolean => {
    const currentUser = useAppSelector(selectCurrentUser);
    return Boolean(currentUser?.is_admin);
};